import { ButtonBase } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const EditPencilButton = ({
  label,
  onClick,
}: {
  label: string;
  onClick?: () => void;
}) => {
  const theme = useTheme();
  return (
    <ButtonBase
      aria-label={label}
      title={label}
      onClick={(event) => {
        if (!onClick) return;
        event.stopPropagation();
        onClick();
      }}
      sx={{
        width: 28,
        height: 28,
        borderRadius: '8px',
        border: `1px solid ${theme.custom?.controlBorder}`,
        background: theme.background.white,
        color: theme.custom?.brandIndigo,
        '&:hover': { background: theme.custom?.hoverBg },
        '& svg': {
          width: 14,
          height: 14,
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 1.8,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        },
      }}
    >
      <svg viewBox="0 0 24 24" aria-hidden>
        <path d="M4 20h4L19 9l-4-4L4 16z" />
        <path d="m13.5 6.5 4 4" />
      </svg>
    </ButtonBase>
  );
};
